<template>
  <div>
    <header>
      <img src="../../assets/Gemnote_logo_text_horizontal.svg" alt="logo" />
    </header>

    <div class="holder">
      <div class="inner-holder">
        <div class="white-bg">
          <h1>Oh!</h1>
          <p>This campaign has ended and is not receiving submissions.</p>

          <div class="button-holder">
            <button @click="$router.push('/report')">Let's head home</button>
          </div>
        </div>

        <div class="black-bg"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error'
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

header {
  height: 62px;
  display: flex;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 2px solid #232220;
}

.holder {
  width: 80%;
  margin: 3.75rem auto;
  background: url('../../assets/error-bg-404.jpeg ') no-repeat center center;
  background-size: cover;
  border-radius: 30px;

  .inner-holder {
    position: relative;
    width: 62%;
    margin: 3rem auto;
    padding: 6.5rem;

    .white-bg {
      position: relative;
      z-index: 50;
      background: $main-white;
      border: 1px solid $onyx;
      border-radius: 20px;
      height: 438px;
      text-align: center;
      padding: 4rem 2rem;
      color: $onyx;

      h1 {
        font-family: $editorial;
        font-size: 6.25rem;
        font-weight: normal;
      }

      p {
        padding-top: 2.5rem;
        font-family: $editorial;
        font-size: 2.5rem;
        font-weight: normal;
        line-height: 50px;
      }

      .button-holder {
        margin-top: 2.5rem;
        display: flex;
        justify-content: center;

        button {
          background: $onyx;
          border: 1px solid $onyx;
          border-radius: 40px;
          color: $main-white;
          height: 3.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          text-transform: uppercase;
          padding: 0 2rem;
          font-size: 0.875rem;
        }
      }
    }

    .black-bg {
      position: absolute;
      top: 142px;
      right: 62px;
      width: 72%;
      background: #232220;
      border: 1px solid #232220;
      border-radius: 20px;
      height: 438px;
      top: 142px;
      right: 62px;
    }
  }
}

@media (max-width: 575.98px) {
  .holder {
    width: 100%;

    .inner-holder {
      width: 100%;
      margin: 10rem auto;
      padding: 1.5rem;

      .white-bg {
        height: auto;
        padding: 4rem 1rem;

        h1 {
          font-size: 5rem;
        }

        p {
          font-size: 2rem;
          font-weight: normal;
          line-height: 42px;
        }
      }

      .black-bg {
        display: none;
      }
    }
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .holder {
    width: 100%;

    .inner-holder {
      width: 100%;
      margin: 10rem auto;
      padding: 1.5rem;

      .white-bg {
        height: auto;
        padding: 4rem 1rem;

        h1 {
          font-size: 5rem;
        }

        p {
          font-size: 2rem;
          font-weight: normal;
          line-height: 42px;
        }
      }

      .black-bg {
        display: none;
      }
    }
  }
}
</style>
